import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";
import IconWarning from "../../../../../components/icons/icon-warning/icon-warning";
import { TOOLTIP_VARIANTS, Tooltip } from "../../../../../components/tooltip/tooltip";
import { TOOLTIP_PLACEMENTS } from "../../../../../components/tooltip/tooltip-box";
import "./rma-require-attention-icon.scss";

interface IProps {
    errorText: string;
}

const RmaRequireAttentionIcon: React.FC<IProps> = ({ errorText }) => {
    return (
        <Tooltip content={<div className="rma-require-attention-tooltip-content">
            <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>
                {errorText}
            </FontBody2>
        </div>}
            variant={TOOLTIP_VARIANTS.ERROR}
            placement={TOOLTIP_PLACEMENTS.RIGHT}
        >
            <IconWarning color="var(--color-accent-3)" />
        </Tooltip>
    );
}

export default RmaRequireAttentionIcon;
